import { render, staticRenderFns } from "./cartOrderDepartment.vue?vue&type=template&id=514936eb&scoped=true&"
import script from "./cartOrderDepartment.vue?vue&type=script&lang=js&"
export * from "./cartOrderDepartment.vue?vue&type=script&lang=js&"
import style0 from "./cartOrderDepartment.vue?vue&type=style&index=0&id=514936eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514936eb",
  null
  
)

export default component.exports